module.exports = __webpack_public_path__ + "img/9.658ba748.jpg";